import type { BlogPost } from '@/types/blog';
import { PostCard } from '@/components/blog/PostCard';

export const PostList = ({ posts }: { posts: BlogPost[] }) => (
  <div className="post-list">
    {posts.map((post) => (
      <PostCard key={post.slug} post={post} />
    ))}
  </div>
);
